import { __assign } from "tslib";
import { reduxKey } from './constants';
import { createSelector } from 'reselect';
import { getPublicSession } from '../../publicSession/selectors';
function getBiStore(state) {
    return state[reduxKey] || { pageview: {} };
}
export function getPageBiContext(state) {
    return getBiStore(state).pageview;
}
export var getPageViewAndComponent = createSelector([getPageBiContext], function (_a) {
    var component = _a.component, view = _a.view;
    return { component: component, view: view };
});
export function getBiContextData(state) {
    return __assign(__assign({}, getPublicSession(state)), getPageViewAndComponent(state));
}
//# sourceMappingURL=selectors.js.map